import React from 'react';
import PropTypes from 'prop-types';
import styles from '../DashboardPage/DashboardPage.module.scss';
import { LiveDataGrid } from '../../components/LiveDataGrid';
import { IDQS_DAY_TRADE_SYMBOL_SUMMARY, IDQS_DAY_TRADE_MMID_SUMMARY, IDQS_DAY_ORDER_SYMBOL_SUMMARY, IDQS_DAY_ORDER_MMID_SUMMARY,
  IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_DAY_OPEN_ORDER_MMID_SUMMARY, IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY, IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_TRADE_SYMBOL_SUMMARY);
const IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_TRADE_MMID_SUMMARY);

const IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_ORDER_SYMBOL_SUMMARY);
const IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_ORDER_MMID_SUMMARY);
const IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY);
const IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_OPEN_ORDER_MMID_SUMMARY);

const IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_UNENTITLED_SYMBOLS_SUMMARY);
const IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY);

class DashboardIdqsGrids extends React.PureComponent {
  render () {
    const pauseRealTimeData = this.props.pauseRealTimeData;
    return (
      <div className={styles.idqsTables} >

        <LiveDataGrid
          identifier={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20} />

        <LiveDataGrid
          identifier={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.header}
          ws={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.ws}
          api={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.api}
          downloadApi={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

        <LiveDataGrid
          identifier={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.identifier}
          header={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.header}
          ws={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.ws}
          api={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.api}
          downloadApi={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.downloadApi}
          lastUpdatedField={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.lastUpdatedField}
          totalField={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.totalField}
          columns={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_DAY_UNENTITLED_SYMBOLS_CONFIG.summaryGroupDataColumn}
          pauseWs={pauseRealTimeData}
          maxRows={20}
        />

      </div>
    );
  }
}

export default DashboardIdqsGrids;
export const MemoizedDashboardIdqsGrids = React.memo(DashboardIdqsGrids);

DashboardIdqsGrids.propTypes = {
  pauseRealTimeData: PropTypes.bool
};
